import React, { useEffect, useMemo, useState } from 'react';
import { Box, Breadcrumbs, Link } from '@mui/material';
import moment from 'moment';
import { Table, WaitDialog } from '@components';
import { useModal } from 'mui-modal-provider';
const OblerEncomendasListView = ({ $state, UIService, OblEncomendaService }) => {
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const { showModal } = useModal();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams());
    const [tecnicos, setTecnicos] = useState([]);
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: '#',
            size: 100,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.Interacao.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Interacao.Processo.numeroProcesso',
            header: 'Nº Processo',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.Interacao.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Interacao.Processo.Cliente.nome',
            header: 'Parceiro',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.Interacao.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Interacao.Processo.parceiro',
            header: 'Nº Parceiro',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.Interacao.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'designacao',
            header: 'Designação',
            size: 250
        },
        {
            accessorKey: 'fornecedor',
            header: 'Fornecedor',
            size: 120
        },
        {
            accessorKey: 'quantidade',
            header: 'Quantidade',
            size: 80,
            Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'decimal', maximumFractionDigits: 2 })}</span>,
            muiTableHeadCellProps: {
                align: 'right'
            },
            muiTableBodyCellProps: {
                align: 'right'
            }
        },
        {
            accessorKey: 'preco',
            header: 'Preço Unitário',
            size: 100,
            Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 }) : '-'}</span>,
            muiTableHeadCellProps: {
                align: 'right'
            },
            muiTableBodyCellProps: {
                align: 'right'
            }
        },
        {
            accessorKey: 'cancelado',
            header: 'Cancelado?',
            Cell: ({ row }) => {
                return row.original.cancelado == 1 ? 'Sim' : 'Não';
            }
        },
        {
            accessorKey: 'justificacao',
            header: 'Justificação'
        },
        {
            accessorKey: 'requisitanteId',
            exportKey: 'row.original.Requisitante.name',
            header: 'Requisitado por',
            filterSelectOptions: tecnicos.map(r => ({
                value: r.id,
                label: r.name
            })),
            Cell: ({ row }) => row.original.Requisitante?.name ?? '-'
        },
        {
            accessorKey: 'dataRequisicao',
            header: 'Data Requisição',
            size: 150,
            Cell: ({ row }) => (row.original.dataRequisicao && moment(row.original.dataRequisicao).isValid() ? moment(row.original.dataRequisicao).format('DD/MM/YYYY HH:mm') : 'N/D')
        },
        {
            accessorKey: 'encomendado',
            header: 'Encomendado?',
            Cell: ({ row }) => {
                return row.original.encomendado == 1 ? 'Sim' : 'Não';
            }
        },
        {
            accessorKey: 'codigo',
            header: 'Código',
            size: 80,
            Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue() : '-'}</span>
        },
        {
            accessorKey: 'prazo',
            header: 'Prazo (dias)',
            size: 80,
            Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue() : '-'}</span>
        },
        {
            accessorKey: 'foraPrazo',
            header: 'Prazo ultrapassado?',
            Cell: ({ row }) => {
                return row.original.encomendado == 1 ? 'Sim' : 'Não';
            }
        },
        {
            accessorKey: 'encomendadoId',
            exportKey: 'row.original.EncomendadoPor.name',
            header: 'Encomendado por',
            filterSelectOptions: tecnicos.map(r => ({
                value: r.id,
                label: r.name
            })),
            Cell: ({ row }) => row.original.EncomendadoPor?.name ?? '-'
        },
        {
            accessorKey: 'dataEncomenda',
            header: 'Data Encomenda',
            size: 150,
            Cell: ({ row }) => (row.original.encomendado && row.original.dataEncomenda && moment(row.original.dataEncomenda).isValid() ? moment(row.original.dataEncomenda).format('DD/MM/YYYY HH:mm') : 'N/D')
        },
        {
            accessorKey: 'rececionado',
            header: 'Rececionado?',
            Cell: ({ row }) => {
                return row.original.rececionado == 1 ? 'Sim' : 'Não';
            }
        },
        {
            accessorKey: 'rececionadoId',
            exportKey: 'row.original.RececionadoPor.name',
            header: 'Receção por',
            filterSelectOptions: tecnicos.map(r => ({
                value: r.id,
                label: r.name
            })),
            Cell: ({ row }) => row.original.Rececionado?.name ?? '-'
        },
        {
            accessorKey: 'dataRececao',
            header: 'Data Receção',
            size: 150,
            Cell: ({ row }) => (row.original.rececionado && row.original.dataRececao && moment(row.original.dataRececao).isValid() ? moment(row.original.dataRececao).format('DD/MM/YYYY HH:mm') : 'N/D')
        }
    ], [tecnicos]);
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const initialFetch = async () => {
        if (loading) {
            setLoading(false);
            const opt = await OblEncomendaService.options();
            setOptions(opt);
            const rTecnicos = await OblEncomendaService.findTecnicos();
            setTecnicos(rTecnicos);
        }
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await OblEncomendaService.table({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) {
            console.log(e);
        }
        setRefetching(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    const excelGen = async (id, array) => {
        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
        let filename = `obler-encomendas-${id ? 'selecao' : 'exportacao'}-${moment().format('YYYY-MM-DD-HH-mm-ss')}.xlsx`;
        let filters = {};
        filter.forEach(r => {
            filters[r.id] = `${getType(r.type)}:${r.value}`;
        });
        if (id) {
            filters['id'] = `$in:${array.join(',')}`;
        }
        else {
            // Aplica filtro temporal
        }
        let sorter = [];
        sort.forEach(r => {
            sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
        });
        try {
            let o = await OblEncomendaService.export({
                columns: columns.map((r) => {
                    return {
                        accessorKey: r.exportKey ?? r.accessorKey,
                        header: r.header
                    };
                }),
                filter: filters,
                sortBy: sorter
            });
            if (o) {
                // Decode Base64 and convert to a Blob
                const binary = atob(o.$data);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }
                // Create a Blob and save it as an Excel file
                const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
        }
        catch (e) {
            if (e && e.data) {
                UIService.addToast(e.data.message);
            }
            else {
                UIService.addToast('Ocorreu um erro ao exportar dados!');
            }
        }
        wait.destroy();
    };
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Obler
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            Encomendas
          </Link>
        </Breadcrumbs>
      </Box>

      <Box>
        <Table onDoubleClick={row => {
            window.open($state.href('app.obler.processos.details', { id: row.Interacao.processoId }, { absolute: true }));
        }} storageKey={$state.current.name} data={data} columns={columns} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} onExport={async () => {
            excelGen(false, []);
        }} quickFilterPresets={[
            {
                key: 'por-encomendar',
                label: 'Por encomendar',
                tooltip: 'Ainda não encomendadas e não canceladas',
                filters: [
                    { id: 'encomendado', value: 0, type: 'equals' },
                    { id: 'cancelado', value: 0, type: 'equals' }
                ]
            },
            {
                key: 'fora-de-prazo',
                label: 'Fora de prazo',
                tooltip: 'Encomendadas mas fora do prazo e não canceladas',
                filters: [
                    { id: 'encomendado', value: 1, type: 'equals' },
                    { id: 'cancelado', value: 0, type: 'equals' },
                    { id: 'foraPrazo', value: 1, type: 'equals' }
                ]
            },
            {
                key: 'nao-rececionadas',
                label: 'Não rececionadas',
                tooltip: 'Encomendadas, não rececionadas, não canceladas',
                filters: [
                    { id: 'encomendado', value: 1, type: 'equals' },
                    { id: 'cancelado', value: 0, type: 'equals' },
                    { id: 'rececionado', value: 0, type: 'equals' }
                ]
            }
        ]} withRowStyle={row => {
            return row.encomendado == 1 && row.cancelado == 0 && row.foraPrazo
                ? {
                    sx: {
                        backgroundColor: '#B00020',
                        '& td': {
                            color: '#FFF'
                        }
                    }
                }
                : {};
        }}/>
      </Box>
    </Box>);
};
export default OblerEncomendasListView;
